t = require('views/internal/teacup-with-helpers')('calendar_toolbar')

module.exports = ->
  t.div '.calendar-header', ->

    t.div '.calendar-header-toolbar', ->

      t.h2 '.calendar-header-toolbar-title.js-calendar-header'

      t.div '.calendar-header-toolbar-today', ->

        t.a '.button-link.today-button.js-today', { href: '#' }, ->
          t.format 'today'

      t.div '.calendar-header-toolbar-nav', ->

        t.a '.button-link.js-left-arrow.left-arrow', { href: '#' }, ->
          t.icon 'up'

        t.a '.button-link.js-right-arrow.right-arrow', { href: '#' }, ->
          t.icon 'down'

      t.div '.calendar-header-toolbar-right', ->
        t.a '.icon-lg.icon-gear.dark-hover.js-calendar-settings', { href: '#' }
        t.a '.icon-lg.icon-close.dark-hover.js-close-calendar', { href: '#' }

      t.div '.calendar-header-toolbar-type', ->

        t.a '.button-link.js-week-view.week-button', { href: '#' }, ->
          t.format 'week'

        t.a '.button-link.js-month-view.month-button', { href: '#' }, ->
          t.format 'month'

    t.div '.days-of-week', ->
      t.mustacheBlock 'days', ->
        t.div '.quiet', ->
          t.text t.mustacheVar('.')

  t.div '.calendar-content'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/calendar_toolbar.coffee